import ObjUtil from './obj'
import encipherUtil from "./encipher";
/**
 * 存储localStorage
 */
export const setStore = (params) => {
  let encipher = new encipherUtil();
  let {
    name,
    content,
    type,
    expire
  } = params;
  let obj = {
    dataType: typeof(content),
    content: content,
    type: type,
    expire: expire || new Date().getTime()+3600*1000*24*7
  }
  if (type) encipher.setSessionStorageAES(name, JSON.stringify(obj));
  else encipher.setLocalStorageAES(name, JSON.stringify(obj));
}
/**
 * 获取localStorage
 */

export const getStore = (params) => {
  let encipher = new encipherUtil();
  let {
    name,
    type,
    debug
  } = params;
  let obj = {};
  let content = null;
  obj = encipher.getLocalStorageAES(name);
  if (ObjUtil.isEmpty(obj))
    obj = encipher.setSessionStorageAES(name);
  if (ObjUtil.isEmpty(obj))
    return;
  obj = JSON.parse(obj);
  if (debug) {
    return obj;
  }
  let current = new Date().getTime()
  if(current>Number(obj.expire)){
    removeStore(obj)
    return
  }
  if (obj.dataType == 'string') {
    content = obj.content;
  } else if (obj.dataType == 'number') {
    content = Number(obj.content);
  } else if (obj.dataType == 'boolean') {
    content = eval(obj.content);
  } else if (obj.dataType == 'object') {
    content = obj.content;
  }
  return content;
}
/**
 * 删除localStorage
 */
export const removeStore = params => {
  let {
    name
  } = params;
  window.localStorage.removeItem(name);
  window.sessionStorage.removeItem(name);
}

/**
 * 获取全部localStorage
 */
export const getAllStore = (params) => {
  let list = [];
  let {
    type
  } = params;
  for (let i = 1; i <= window.sessionStorage.length; i++) {
    if (type) {
      list.push({
        name: window.sessionStorage.key(i),
        content: getStore({
          name: window.sessionStorage.key(i),
          type: 'session'
        })
      })
    } else {
      list.push(getStore({
        name: window.localStorage.key(i),
        content: getStore({
          name: window.localStorage.key(i),
        })
      }))
    }
  }

  return list;

}

/**
 * 清空全部localStorage
 */
export const clearStore = (params) => {
  let {
    type
  } = params;
  if (type) {
    window.sessionStorage.clear();
    return
  }
  window.localStorage.clear()
}


/**
 * 清空全部localStorage
 */
export const getToken = () => {
  let encipher = new encipherUtil();

  let tokenObj = {};

  tokenObj = encipher.getLocalStorageAES('token');
  if(!tokenObj){
    return null;
  }
  tokenObj = JSON.parse(tokenObj);
  return tokenObj.content;
}

